import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import ServiceDetailsLanding from "../views/ServiceDetailsLanding";
import { Helmet } from "react-helmet-async";

export default function Services(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ServicesLanding />;
    }

    if (appContext.navSubItem === "service" && appContext.navExtraItem) {
      return <ServiceDetailsLanding uuid={appContext.navExtraItem} />;
    }

    return null;
  }

  const getMetatags = () => {
    if (appContext.navSubItem === "service" && appContext.navExtraItem) {
      //individual service page
      const service = appContext.allServices.find(
        (s) => s.uuid === appContext.navExtraItem,
      );
      return {
        title: service
          ? `${service.title} | Zanzibar Tours`
          : "Service Details | Zanzibar Tours",
        description: service
          ? service.shortDescription || service.description?.substring(0, 160)
          : "View our amazing services",
        url: `https://zanzibarmissiontour.com/#/services/service/${appContext.navExtraItem}`,
      };
    }
    // Services listing page
    return {
      title: "Our Services | Zanzibar Mission Tours",
      description:
        "Explore all our amazing services including safaris, accommodations, tours, and travel packages in Zanzibar and Tanzania.",
      url: "https://zanzibarmissiontour.com/#/services",
    };
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  const meta = getMetatags();
  return (
	<>
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.url} />
    </Helmet>
    {view}
  </>
  );
}
